import { createFileRoute } from '@tanstack/react-router';
import { TableExplorer } from '~/components/admin/TableExplorer';

const TABLES = [
  { key: 'jobs',                label: 'Jobs' },
  { key: 'customers',           label: 'Customers' },
  { key: 'claims',              label: 'Claims' },
  { key: 'insurance_carriers',  label: 'Carriers' },
  { key: 'external_contacts',   label: 'External Contacts' },
  { key: 'compliance_tasks',    label: 'Compliance Tasks' },
  { key: 'marketing_leads',     label: 'Marketing Leads' },
  { key: 'plumbers',            label: 'Plumbers' },
  { key: 'changelog_entries',   label: 'Updates' },
  { key: 'warehouse_areas',     label: 'Warehouse Areas' },
];

export const Route = createFileRoute('/_app/admin/tables')({
  component: () => (
    <div className="px-6 py-6 max-w-[1400px] mx-auto">
      <h1 className="font-display text-3xl font-bold text-[var(--color-navy)]">Database Tables</h1>
      <p className="text-sm text-[var(--color-ink-soft)] mt-1 mb-6">
        Spreadsheet-style editor. Click any non-system cell to edit. Boolean cells toggle on click.
        Changes save immediately and bypass RLS via the admin endpoint — be careful.
      </p>
      <TableExplorer tables={TABLES} />
    </div>
  ),
});
